// What was made of a submitted update (TX-US-0029): its summary, and its transcript behind a
// disclosure - the English translation first where the BD spoke French, the original beside it.
//
// All of it is written by a model and says so. It sits under the BD's own text and never in place
// of it; an update still being processed, or one that could not be, says that instead.

import { statusLine, transcriptParts } from './processing.js';

export default function SessionInsight({ session }) {
  const { summary, transcript } = session;
  const status = statusLine(session);

  if (!summary && !transcript && !status) return null;

  return (
    <div className="hub-insight">
      {status && (
        <p className={`hub-insight-status ${session.processing_status.toLowerCase()}`} role="status">
          {status}
        </p>
      )}

      {summary && (
        <section className="hub-summary" aria-label="Summary">
          <p className="hub-insight-label">Summary · written by AI</p>
          <p className="hub-summary-headline">{summary.headline}</p>
          <ul>
            {summary.points.map((point) => <li key={point}>{point}</li>)}
          </ul>
        </section>
      )}

      {transcript && (
        <details className="hub-transcript">
          <summary>Transcript</summary>
          {transcriptParts(transcript).map((part) => (
            <section key={part.label ?? 'transcript'}>
              {part.label && <p className="hub-insight-label">{part.label}</p>}
              <p className="hub-transcript-text">{part.text}</p>
            </section>
          ))}
        </details>
      )}
    </div>
  );
}
